import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Card, Icon, Input, Button } from "antd";
import moment from "moment";
import axios from "axios";
import { Translate, Translator } from "react-translated";
import F from "../../Functions";
import AssociateUserTags from "../../components/associate-user-tags";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class SearchCustomersToMergeWith extends Component {
  state = {
    loading: false,
    bfiles: [],
    agency_id: "",
    user: this.props.auth.user,
    search: "",
    selectedRowIndexes: [], // [1,3] ==>> indexes
    selectedRowBFileData: [], // []
  };

  RadioRenderer = (params) => {
    const checked = params.node && params.node.isSelected && params.node.isSelected();
    return (
      <input
        type="radio"
        checked={!!checked}
        onChange={() => {
          if (params && params.node) params.node.setSelected(true);
        }}
        style={{ cursor: 'pointer' }}
      />
    );
  };

  onSearch = () => {
    const { search } = this.state;

    const searchPurify = F.removeSpecialCharactersFromString(search);

    if (searchPurify.trim().length > 0) {
      this.setState({ loading: true });

      axios.get("/api/search_bfile_m/" + searchPurify).then((res) => {
        this.setState({
          loading: false,
          bfiles: res.data,
        });
      });
    }
  };
  onSelectionChanged = (event) => {
    const { bfiles } = this.state;
    const api = event && event.api;
    if (!api) return;
    const selectedNodes = api.getSelectedNodes();
    const selectedRowIndexes = selectedNodes
      .map(n => (n && n.data && typeof n.data.idx === 'number') ? n.data.idx : undefined)
      .filter(idx => typeof idx === 'number');
    const selectedRowBFileData = selectedRowIndexes.map(idx => bfiles[idx]).filter(Boolean);
    this.setState({ selectedRowIndexes, selectedRowBFileData });
  };

  mergeCustomer = () => {
    // Remove previous "selected duplicate customers" from local storage
    window.localStorage.removeItem("customersToMerge");

    // Add new "selected duplicate customers" in local storage key "customersToMerge"
    window.localStorage.customersToMerge = JSON.stringify(
      this.state.selectedRowBFileData
    );

    // navigate to "merge-customers" route
    setTimeout(() => {
      this.props.history.push("/merge-customers");
    }, 100);
  };

  render() {
    const {
      loading,
      bfiles,
      selectedRowIndexes,
      selectedRowBFileData,
    } = this.state;

    const columnDefs = [
      {
        headerName: '',
        field: 'radio',
        width: 50,
        sortable: false,
        filter: false,
        suppressMenu: true,
        cellRendererFramework: this.RadioRenderer,
      },
      {
        headerName: 'Name',
        field: 'name',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Name'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Created Date',
        field: 'created_on',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Created Date'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Agency Name',
        field: 'agency_name',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Agency Name'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Phone',
        field: 'phone',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Phone'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Email',
        field: 'email',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Email'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Associate Users',
        field: 'associate_users',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Associate Users'] },
        sortable: true,
        cellRendererFramework: params => <AssociateUserTags associate_users={params.value} />,
      },
    ];

    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      let bfile = bfiles[i];
      let stage = "";
      let today = new Date();
      if (
        bfile.vob_attempted == null &&
        bfile.vob_completed == null &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Claimed";
      }
      if (
        (bfile.onboarding_id == null ||
          bfile.onboarding_user_type != "VONBOARDER") &&
        new Date(bfile.expiration_date) < today
      ) {
        stage = "Due Calls";
      }
      if (
        bfile.vob_attempted == 1 &&
        bfile.vob_completed == null &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Attempted Calls";
      }
      if (
        (bfile.onboarding_id == null ||
          bfile.onboarding_user_type != "VONBOARDER") &&
        new Date(bfile.expiration_date) >= today
      ) {
        stage = "Upcoming Calls";
      }
      if (
        bfile.vob_completed == 1 &&
        bfile.not_interested == 0 &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Completed Calls";
      }
      if (
        bfile.vob_completed == 1 &&
        bfile.not_interested == 1 &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Not Reached Archived";
      }

      let bfile_name = bfile.first_name + " " + bfile.last_name;
      if (!bfile.last_bfile) {
        bfile_name = (
          <div style={{ paddingLeft: 20 }}>
            {bfile.first_name + " " + bfile.last_name}
          </div>
        );
      }

      data.push({
        idx: i,
        name: bfile_name,
        created_on: moment(new Date(bfile.date)).format("MM/DD/YYYY"),
        agency_name: bfile.agency_name,
        status: stage,
        phone: bfile.phone,
        email: bfile.email,
        // associate_users: bfile.Associated_bfiles.concat(
        //   bfile.Associated_bfiles
        // ),
        associate_users: bfile.Associated_bfiles,
      });
    }


    F.log("selectedRowBFileData==>>", JSON.stringify(selectedRowBFileData));

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Translate text={`Search Customers To Merge With`} />
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <Row
              gutter={16}
              //   style={{ maxWidth: "100%" }}
              type="flex"
              justify="end"
            >
              <Translator>
                {({ translate }) => (
                  <Input
                    prefix={<Icon type="search" />}
                    value={this.state.search}
                    placeholder={translate({ text: `Search` }) + "..."}
                    onChange={(e) => this.setState({ search: e.target.value })}
                    onPressEnter={this.onSearch}
                  />
                )}
              </Translator>
            </Row>
          }
        >
          {selectedRowIndexes.length > 0 ? (
            <div className="toolbarButtons">
              <Button type="default" onClick={this.mergeCustomer}>
                <Translate text={`Merge Customer`} />
              </Button>
            </div>
          ) : null}
          <CustomAgGridTable
            rowDatas={data}
            columnDefss={columnDefs}
            rowSelection="single"
            onSelectionChanged={this.onSelectionChanged}
            gridApiOptions={{
              immutableData: true,
              getRowId: params => (params && params.data && typeof params.data.idx !== 'undefined') ? String(params.data.idx) : undefined,
            }}
          />
        </Card>
      </div>
    );
  }
}

export default SearchCustomersToMergeWith;



// WEBPACK FOOTER //
// ./src/scenes/SearchCustomersToMergeWith/index.js